import React from 'react';

import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Flex,
  Icon,
  Skeleton,
} from '@chakra-ui/react';

import {
  FaChartLine,
  FaClock,
  FaCheckCircle,
  FaExclamationTriangle,
  FaList,
  FaPause,
} from 'react-icons/fa';

import { useColors } from './colors';

const SummaryStats = ({ statusCounts, isLoading = false }) => {
  const { textColor, backgroundCardColor, secondaryTextColor } = useColors();

  // Use real data from props, fallback to dummy data
  const overview = statusCounts || {
    totalOptimized: 0,
    activeOptimizations: 0,
    inactiveOptimizations: 0,
    winningOptimizations: 0,
    readyForReview: 0,
    queueOptimizations: 0,
    holdOptimizations: 0,
  };

  const stats = [
    {
      label: 'Total Optimized',
      value: overview.totalOptimized,
      icon: FaCheckCircle,
      helpText: 'Overall total',
      color: 'green.500',
    },
    {
      label: 'Active Optimizations',
      value: overview.activeOptimizations,
      icon: FaClock,
      helpText: 'Running now',
      color: 'blue.500',
    },
    {
      label: 'Inactive Optimizations',
      value: overview.inactiveOptimizations,
      icon: FaExclamationTriangle,
      helpText: 'Not running',
      color: 'orange.500',
    },
    {
      label: 'Winning Optimizations',
      value: overview.winningOptimizations,
      icon: FaChartLine,
      helpText: 'Cheaper than competitors',
      color: 'green.500',
    },
    {
      label: 'Queue Optimizations',
      value: overview.queueOptimizations,
      icon: FaList,
      helpText: 'Ready to activate',
      color: 'blue.500',
    },
    {
      label: 'Hold Optimizations',
      value: overview.holdOptimizations,
      icon: FaPause,
      helpText: 'On hold',
      color: 'gray.500',
    },
  ];

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 6 }} spacing={4} mb={4}>
      {stats.map((stat, index) => (
        <Box key={index} p={6} bg={backgroundCardColor} borderRadius="lg" boxShadow="sm">
          <Flex justify="space-between" align="center">
            <Stat>
              <StatLabel color={textColor} fontSize="sm">
                {stat.label}
              </StatLabel>
              <Skeleton isLoaded={!isLoading}>
                <StatNumber color={textColor} fontSize="2xl">
                  {stat.value}
                </StatNumber>
              </Skeleton>
              {stat.helpText && (
                <StatHelpText color={secondaryTextColor}>{stat.helpText}</StatHelpText>
              )}
            </Stat>
            <Icon as={stat.icon} boxSize={8} color={stat.color} />
          </Flex>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default SummaryStats;
